import { useHistory } from 'react-router-dom';

const allowedSlugs: string[] = [
  '/service/doula',
  '/service/birth-education',
  '/service/infant-sleep',
  '/service/lactation',
  '/learn/signs-of-labor',
  '/learn/classes-to-take-before-baby',
  '/learn/skin-to-skin-bonding',
  '/learn/induction-process',
  '/learn/stages-of-labor',
  '/learn/why-is-childbirth-education-important',
  '/learn/what-do-you-do-in-childbirth-education-classes',
  '/learn/what-is-the-difference-between-a-midwife-and-a-doula',
  '/learn/what-is-a-doula',
  '/learn/when-does-lactation-start',
  '/learn/preparing-for-breastfeeding',
  '/learn/breastfeeding-problems',
  '/learn/infant-sleep-5-best-tips-you-need-to-know',
  '/learn/how-many-hours-should-your-infant-sleep',
  '/learn/how-to-set-a-sleep-schedule-for-your-infant',
  '/learn/babies-sleeping-through-the-night',
  '/learn/postpartum-recovery',
  '/learn/physical-therapy-after-pregnancy-everything-you-need-to-know',
  '/learn/prenatal-fitness',
  '/learn/what-is-diastasis-recti',
  '/learn/what-is-postnatal-yoga',
  '/learn/ppd-baby-blues',
  '/learn/motherhood-identity',
  '/learn/pregnancy-and-mental-health',
  '/learn/prenatal-nutrition',
  '/learn/breastfeeding-diet-food-limitations-even-after-giving-birth',
];

export const useIsAllowedSlug = () => {
  const {
    location: { pathname },
  } = useHistory();
  return allowedSlugs.some((allowedSlug) => allowedSlug === pathname);
};
